export const animationSettings = {
  'shots': {
    'default': ['static'],
    'STATE:OUT:FS-ADD': ['static'],
    'STATE:IN:FS-ADD': ['play', false],
  },

  'lapm': {
    'default': ['static'],
    'STATE:OUT:FS-ADD': ['static'],
    'STATE:IN:FS-ADD': ['play', false],
  },

  'logo-win': {
    'default': ['static'],
    'STATE:OUT:WIN': ['static'],
    'WIN-ANIMATE': ['play', false],
  },
  'reel-bgr': {
    'default': ['static'],
    'ACTION:FS-START': ['static'],
    'INIT:FREESPINS': ['play', false],
    'BUTTON:startFreespin': ['play', false],
    'PLATFORM-STOP': ['end'],
  },
}
